export default __webpack_public_path__ + "static/media/pen.e4a189be.svg";